module.exports = __webpack_public_path__ + "media/images/plus-e660941a30286d647cb16dcfd02e7e2a.svg";